import { updateRenewalToken, updateSessionUuid, updateToken } from '@redux/authent/authent.reducer';
import { AUTHENT_URL, authentApi } from '@services/authent/authent.api';

export const securityApi = authentApi.injectEndpoints({
  endpoints: (builder) => ({
    renewToken: builder.mutation<{ token: string | null; renew: string | null; sessionUuid: string | null }, void>({
      query: () => ({
        url: `${AUTHENT_URL}/token/renew`,
        method: 'POST',
      }),
      transformResponse: (_, meta) => {
        return {
          token: meta?.response?.headers.get('AUTHORIZATION') ?? null,
          renew: meta?.response?.headers.get('RENEWAL') ?? null,
          sessionUuid: meta?.response?.headers.get('Session-Uuid') ?? null,
        };
      },
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;
        dispatch(updateToken(data.token));
        dispatch(updateRenewalToken(data.renew));
        dispatch(updateSessionUuid(data.sessionUuid));
      },
    }),
    resourceToken: builder.mutation<{ resourceToken: string | null }, void>({
      query: () => ({
        url: `${AUTHENT_URL}/token/resource`,
        method: 'POST',
      }),
    }),
  }),
});

export const { useRenewTokenMutation, useResourceTokenMutation } = securityApi;
